const host = process.env.NODE_ENV == 'production'? '//'+location.host : '//cas.gtafe.com';
export default {
    hostLogin: host + '/apiuc',
    timeout: 10000,
    MOCK: false
}
